export default __webpack_public_path__ + "static/macmillan-friends-97070588bb1a89b9167ced36e550f7d0.jpg";